export default "__VITE_ASSET__BtDnFJNX__"